/* Manual price inputs with filtered suggestions. */
(function () {
	'use strict';

	var priceFilters = document.querySelectorAll('.btr-price-filter');

	for (var filterIndex = 0; filterIndex < priceFilters.length; filterIndex++) {
		initPriceFilter(priceFilters[filterIndex]);
	}

	function initPriceFilter(filter) {
		var priceInput = filter.querySelector('.btr-price-input');
		var suggestions = filter.querySelector('.btr-price-suggestions');
		if (!priceInput || !suggestions) {
			return;
		}

		var options = suggestions.querySelectorAll('.btr-price-suggestion');

		function closeSuggestions() {
			suggestions.hidden = true;
			priceInput.setAttribute('aria-expanded', 'false');
		}

		function updateSuggestions() {
			var query = priceInput.value.trim();
			var hasMatches = false;

			for (var i = 0; i < options.length; i++) {
				var matches = !query || options[i].getAttribute('data-price').indexOf(query) !== -1;
				options[i].hidden = !matches;
				hasMatches = hasMatches || matches;
			}

			suggestions.hidden = !hasMatches;
			priceInput.setAttribute('aria-expanded', hasMatches ? 'true' : 'false');
		}

		function focusOption(startIndex, direction) {
			for (var i = startIndex; i >= 0 && i < options.length; i += direction) {
				if (!options[i].hidden) {
					options[i].focus();
					return;
				}
			}
		}

		priceInput.addEventListener('focus', updateSuggestions);
		priceInput.addEventListener('input', updateSuggestions);
		priceInput.addEventListener('keydown', function (event) {
			if (event.key === 'ArrowDown' && !suggestions.hidden) {
				event.preventDefault();
				focusOption(0, 1);
			} else if (event.key === 'Escape') {
				closeSuggestions();
			}
		});

		suggestions.addEventListener('mousedown', function (event) {
			event.preventDefault();
		});

		suggestions.addEventListener('click', function (event) {
			var option = event.target.closest('.btr-price-suggestion');
			if (!option) {
				return;
			}

			priceInput.value = option.getAttribute('data-price');
			priceInput.dispatchEvent(new Event('input', { bubbles: true }));
			priceInput.focus();
			closeSuggestions();
		});

		suggestions.addEventListener('keydown', function (event) {
			var currentIndex = Array.prototype.indexOf.call(options, event.target);

			if (event.key === 'ArrowDown') {
				event.preventDefault();
				focusOption(currentIndex + 1, 1);
			} else if (event.key === 'ArrowUp') {
				event.preventDefault();
				if (currentIndex <= 0) {
					priceInput.focus();
				} else {
					focusOption(currentIndex - 1, -1);
				}
			} else if (event.key === 'Escape') {
				priceInput.focus();
				closeSuggestions();
			}
		});

		document.addEventListener('click', function (event) {
			if (!filter.contains(event.target)) {
				closeSuggestions();
			}
		});
	}
})();
